<div>
  <app-message [service]="messageService"></app-message>

  <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)">

    <div class="form-group mb-2">
      <label for="name" i18n="@@PricingNameLabel">Name*</label>
      <input type="text" id="name" formControlName="name" class="form-control" i18n-placeholder="@@PricingNamePlaceholder" placeholder="Name" ngbAutoFocus />

      <div class="error">
        <em *ngIf="formService.validateControl('name') && formService.hasError('name', 'required')" i18n="@@NameRequiredErrorMessage">Name wird benötigt</em>
      </div>
    </div>

    <div class="form-group mb-2">
      <label for="description" i18n="@@DescriptionLabel">Beschreibung</label>
      <textarea type="text" id="description" formControlName="description" class="form-control" i18n-placeholder="@@DescriptionPlaceholder" placeholder="Beschreibung" rows="2"></textarea>

      <div class="error">
        <em *ngIf="formService.validateControl('description') && formService.hasError('description', 'required')" i18n-placeholder="@@CurrencyUnitPerKwhPlaceholder" i18n="@@DescriptionRequiredErrorMessage" >Beschreibung wird benötigt</em>
      </div>
    </div>

    <div class="form-group mb-2">
      <label for="price"
        i18n-ngbTooltip="@@PriceNotEditableWarningTooltip"
        ngbTooltip="Bitte beachten Sie, dass eine nachträgliche Änderung des Preises nicht möglich ist,
        da dieser Gegenstand von Rechnungen wird. Sie können stattdessen Tarife austauschen.">
        Euro pro Kilowattstunde (kWh)*</label>
      <div class="d-flex gap-1" id="prices">
        <div class="d-flex">
          <input type="text" value="AC" disabled>
          <input id="price"
            type="text"
            mask="0,00"
            [showMaskTyped]="true"
            prefix="€ "
            formControlName="price"
            class="form-control"
            placeholder="für Laden mit AC" />
        </div>
        <div class="d-flex">
          <input type="text" value="DC" disabled
          i18n-ngbTooltip="@@PriceDcInfo"
          ngbTooltip="Laden über DC ist in der Regel teurer als Laden über AC, weil die Belastung für das Netz größer ist.">
          <input id="priceDc"
            type="text"
            mask="0,00"
            [showMaskTyped]="true"
            prefix="€ "
            formControlName="priceDc"
            class="form-control"
            placeholder="für Laden mit DC" />
        </div>
      </div>
      
      <div class="error">
        <em *ngIf="formService.validateControl('price') && formService.hasError('price', 'required') || formService.validateControl('priceDc') && formService.hasError('priceDc', 'required')"
          i18n="@@PriceCurrencyUnitPerKwhRequiredErrorMessage">Euro pro Kilowattstunde (kWh) wird benötigt</em>
      </div>
    </div>

    <div class="form-group mb-2" *ngIf="pricings && pricingType != 'QR-Code'">
      <label i18n="@@ExistingPricingReplaceLabel"
      i18n-ngbTooltip="@@ExistingPricingReplaceTooltip"
      ngbTooltip="Die Benutzer des zu ersetzenden Tarifs werden für diesen neuen Tarif übernommen">
      Bestehenden Tarif ersetzen</label>
      <ng-select [(ngModel)]="pricingToReplace"
        placeholder="Wählen Sie einen bestehenden Tarif aus"
        [multiple]="false"
        [closeOnSelect]="false"
        [clearSearchOnAdd]="true"
        appendTo="body"
        bindLabel="name"
        notFoundText="Keine Tarife vorhanden"
        (change)="updatedPricingToReplace()"
        formControlName="pricingToReplace">
        <ng-option *ngFor="let pricing of pricings" [value]="pricing.id">{{ pricing.name }}</ng-option>
      </ng-select>
      <!-- <label for="archivePricingToReplace" class="mt-2">
        <input type="checkbox" id="archivePricingToReplace" formControlName="archivePricingToReplace" class="form-control ml-0 form-check-input" />
        <span class="ml-4"  i18n="@@ArchiveReplacedPricing">Ersetzten Tarif archivieren</span>
      </label> -->
    </div>

    <div class="form-group" *ngIf="pricingType != 'QR-Code'">
      <label i18n="@@SelectUsersLabel">Benutzer auswählen</label>
      <input *ngIf="availableUsers.length < 1" disabled [placeholder]="usersSelectEmpty" class="form-control">
      <ng-container *ngIf="availableUsers.length >= 1">
        <ng-select [items]="availableUsers"
          i18n-placeholder="@@SelectUsersPlaceholder"
          placeholder="Wählen Sie Benutzer aus"
          [multiple]="true"
          [hideSelected]="true"
          [closeOnSelect]="false"
          [clearSearchOnAdd]="true"
          id="users"
          appendTo="body"
          bindLabel="fullName"
          [compareWith]="compareUsersById"
          [searchFn]="userMultiSelectSearchFn"
          i18n-notFoundText="@@NoEntriesAvailable"
          notFoundText="Keine Einträge vorhanden"
          formControlName="selectedUsers"
          class="group-assignment-select group-assignment-select--picker">
          <ng-template ng-option-tmp let-item="item">
            <span class="px-2">{{ item.fullName + ' (' + item.email + ')' }}</span>
          </ng-template>
        </ng-select>
        <div class="assigned-items-list" aria-label="Zugeordnete Benutzer">
          <div *ngFor="let user of assignedUsers; trackBy: trackUserById" class="assigned-items-list__item">
            <span class="assigned-items-list__label">{{ getUserDisplayName(user) }}</span>
            <button type="button" class="assigned-items-list__remove" (click)="clear(user)"
              aria-label="Benutzer entfernen">×</button>
          </div>
          <div *ngIf="assignedUsers.length === 0" class="assigned-items-list__empty">
            Keine Benutzer zugeordnet
          </div>
        </div>
      </ng-container>
    </div>
  </form>
</div>
